export const PURCHASE_BY_SAVED_CARD='PURCHASE_BY_SAVED_CARD'
export const PURCHASE_BY_SAVED_CARD_SUCCESS='PURCHASE_BY_SAVED_CARD_SUCCESS'
export const PURCHASE_BY_SAVED_CARD_ERROR='PURCHASE_BY_SAVED_CARD_ERROR'

export const PurchaseBySavedCard = (data) => ({
    type: PURCHASE_BY_SAVED_CARD,
    payload: data
})